/* Ordiajade : barre d'achat fixe des fiches produit (sections/product.liquid, bloc « cart-bar »).
   Sur ordinateur et sur mobile :
   - la barre apparaît en bas de l'écran dès que le bouton « Ajouter au panier » principal est sorti de l'écran par le haut ;
   - les variantes sont proposées en pastilles, recopiées du formulaire principal (même ordre, mêmes couleurs) ;
     cliquer une pastille choisit la variante dans le formulaire principal, qui met à jour prix, photo et disponibilité ;
   - « AJOUTER AU PANIER » ajoute la variante choisie par le même chemin que le bouton principal
     (ajout sans rechargement, ouverture du tiroir panier), en un seul clic.
   La barre d'origine du thème est remplacée : sections/product.liquid ne pose plus data-cart-bar-enabled. */
(function () {
  var TEXTE_AJOUT = 'AJOUTER AU PANIER';
  var TEXTE_EPUISE = 'ÉPUISÉ';

  function initialiser(barre) {
    if (barre.dataset.ordiaPret) return;
    var section = barre.closest('[data-section-type="product"]');
    var formulaire = section && section.querySelector('[data-product-form]');
    var boutonPrincipal = formulaire && formulaire.querySelector('[data-add-to-cart]');
    var bouton = barre.querySelector('[data-ordia-bar-ajouter]');
    if (!boutonPrincipal || !bouton) return;
    barre.dataset.ordiaPret = '1';

    var texteBouton = bouton.querySelector('[data-ordia-bar-texte]');
    var enveloppe = barre.querySelector('[data-ordia-bar-wrapper]');
    var zoneOptions = barre.querySelector('[data-ordia-bar-options]');
    var zonePrix = barre.querySelector('[data-ordia-bar-prix]');
    var groupes = [];

    /* Pastilles : une rangée par option qui propose au moins deux valeurs (Couleur, Taille…) */
    function construirePastilles() {
      if (!zoneOptions) return;
      zoneOptions.innerHTML = '';
      groupes = [];
      section.querySelectorAll('.selector-wrapper[data-option-position]').forEach(function (bloc) {
        if (bloc.closest('[data-ordia-bar]')) return;
        var nomOption = bloc.querySelector('.radio__legend__option-name, label');
        var choix = [];
        bloc.querySelectorAll('input[type="radio"][data-single-option-selector]').forEach(function (entree) {
          choix.push({ valeur: entree.value, entree: entree, pastille: entree.closest('radio-swatch, .swatch__button') });
        });
        if (!choix.length) {
          var liste = bloc.querySelector('select[data-single-option-selector], select');
          if (liste) [].forEach.call(liste.options, function (option) { choix.push({ valeur: option.value, liste: liste, option: option }); });
        }
        if (choix.length < 2) return;

        var rangee = document.createElement('div');
        rangee.className = 'ordia-bar__groupe';
        rangee.setAttribute('role', 'radiogroup');
        if (nomOption) rangee.setAttribute('aria-label', nomOption.textContent.trim());

        choix.forEach(function (c) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ordia-bar__pastille';
          b.setAttribute('role', 'radio');
          var couleur = c.pastille ? getComputedStyle(c.pastille).getPropertyValue('--swatch').trim() : '';
          if (couleur) {
            var rond = document.createElement('span');
            rond.className = 'ordia-bar__rond';
            rond.style.background = couleur;
            b.appendChild(rond);
          }
          var nom = document.createElement('span');
          nom.className = 'ordia-bar__nom';
          nom.textContent = c.valeur;
          b.appendChild(nom);
          b.addEventListener('click', function () {
            if (b.disabled) return;
            if (c.entree) {
              if (!c.entree.checked) c.entree.click();
            } else if (c.liste.value !== c.valeur) {
              c.liste.value = c.valeur;
              c.liste.dispatchEvent(new Event('change', { bubbles: true }));
            }
            setTimeout(synchroniser, 80);
          });
          c.bouton = b;
          rangee.appendChild(b);
        });
        zoneOptions.appendChild(rangee);
        groupes.push(choix);
      });
      zoneOptions.hidden = !groupes.length;
    }

    /* Recopie l'état du formulaire principal : pastille choisie, valeurs épuisées, prix, bouton */
    function synchroniser() {
      var uneSeuleOption = groupes.length === 1;
      groupes.forEach(function (choix) {
        choix.forEach(function (c) {
          var choisie = c.entree ? c.entree.checked : c.liste.value === c.valeur;
          var epuisee = c.entree
            ? (c.entree.classList.contains('sold-out') || c.entree.classList.contains('unavailable') || c.entree.disabled)
            : c.option.disabled;
          c.bouton.classList.toggle('is-selected', choisie);
          c.bouton.setAttribute('aria-checked', choisie ? 'true' : 'false');
          c.bouton.classList.toggle('is-soldout', epuisee);
          c.bouton.disabled = uneSeuleOption && epuisee && !choisie;
          c.bouton.title = c.valeur + (epuisee ? ' (épuisé)' : '');
        });
      });

      var prixPrincipal = null;
      section.querySelectorAll('[data-price-wrapper]').forEach(function (p) {
        if (!prixPrincipal && !p.closest('[data-ordia-bar]')) prixPrincipal = p;
      });
      if (prixPrincipal && zonePrix) zonePrix.innerHTML = prixPrincipal.innerHTML;

      /* Disponibilité lue sur l'enveloppe du formulaire principal (le bouton principal, lui, est aussi
         désactivé pendant un ajout en cours : il ne faut pas afficher « Épuisé » à ce moment-là) */
      var enveloppePrincipale = boutonPrincipal.closest('[data-form-wrapper]');
      var indisponible = enveloppePrincipale
        ? (enveloppePrincipale.classList.contains('variant--soldout') || enveloppePrincipale.classList.contains('variant--unavailable'))
        : boutonPrincipal.disabled;
      texteBouton.textContent = indisponible ? TEXTE_EPUISE : TEXTE_AJOUT;
      if (enveloppe) enveloppe.classList.toggle('variant--soldout', indisponible);
      if (!bouton.classList.contains('is-loading') && !bouton.classList.contains('is-added')) bouton.disabled = indisponible;
    }

    /* Apparition : quand le bouton principal est sorti de l'écran par le haut */
    var visible = false;
    function mesurer() {
      var hauteur = barre.offsetHeight;
      document.documentElement.style.setProperty('--cart-bar-height', hauteur + 'px');
      document.documentElement.style.setProperty('--ordia-bar-decalage', visible ? hauteur + 'px' : '0px');
    }
    function afficher(etat) {
      if (etat === visible) return;
      visible = etat;
      barre.classList.toggle('is-visible', etat);
      barre.setAttribute('aria-hidden', etat ? 'false' : 'true');
      document.body.classList.toggle('cart-bar-visible', etat);
      mesurer();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        var e = entrees[entrees.length - 1];
        afficher(!e.isIntersecting && e.boundingClientRect.bottom <= 0);
      }).observe(boutonPrincipal);
    }

    /* Ajout au panier en un clic : même chemin que le bouton principal (Ajax + tiroir panier) */
    var minuteur;
    bouton.addEventListener('click', function (evenement) {
      evenement.preventDefault();
      if (bouton.disabled || boutonPrincipal.disabled || bouton.classList.contains('is-loading')) return;
      bouton.classList.add('is-loading');
      bouton.setAttribute('disabled', 'disabled');
      boutonPrincipal.dispatchEvent(new Event('click', { bubbles: true }));
      clearTimeout(minuteur);
      minuteur = setTimeout(function () {
        bouton.classList.remove('is-loading');
        synchroniser();
      }, 6000);
    });
    function finAjout() {
      clearTimeout(minuteur);
      bouton.classList.remove('is-loading');
      /* Le thème affiche la coche « ajouté » une seconde puis réactive les boutons */
      setTimeout(synchroniser, 1200);
    }
    document.addEventListener('theme:product:add', finAjout);
    document.addEventListener('theme:product:added', finAjout);
    document.addEventListener('theme:product:add-error', finAjout);
    document.addEventListener('theme:cart:error', finAjout);

    /* Article épuisé avec alerte e-mail : ouvre la même fenêtre que sur la fiche */
    var alerte = barre.querySelector('[data-cart-bar-product-notification]');
    if (alerte) {
      alerte.addEventListener('click', function (evenement) {
        evenement.preventDefault();
        var ouvrir = section.querySelector('[data-popup-open]');
        if (ouvrir) ouvrir.dispatchEvent(new Event('click'));
      });
    }

    section.addEventListener('theme:variant:change', function () { setTimeout(synchroniser, 30); });
    section.addEventListener('change', function () { setTimeout(synchroniser, 80); });
    window.addEventListener('resize', mesurer);

    construirePastilles();
    synchroniser();
    mesurer();
  }

  function demarrer() {
    document.querySelectorAll('[data-ordia-bar]').forEach(initialiser);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
  document.addEventListener('shopify:section:load', demarrer);
})();
